import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { useGetTenantSearchQuery } from '@/services/tenant/webPage'
import type { UserRoleEnum } from '@/types'
import { ROLE_LABELS } from '@/types'

type SearchItem = {
    id: number
    fullName: string
    email: string
    phone: string
    roles: UserRoleEnum[]
}

type Results = {
    technicians: SearchItem[]
    customers: SearchItem[]
    orders: SearchItem[]
}

const SearchPage = () => {
    const [searchParams] = useSearchParams()
    const searchValue = searchParams.get('search') || ''
    const { data } = useGetTenantSearchQuery(searchValue, {
        skip: !searchValue,
    })
    const navigate = useNavigate()

    const [results, setResults] = useState<Results>({
        technicians: [],
        customers: [],
        orders: [],
    })

    useEffect(() => {
        if (data?.data) {
            const sortedResults = Object.entries(data.data)
                .sort((a, b) => b.length - a.length)
                .reduce((acc, [key, value]) => {
                    acc[key as keyof Results] = value
                    return acc
                }, {} as Results)

            setResults(sortedResults)
        } else {
            setResults({ technicians: [], customers: [], orders: [] })
        }
    }, [data])

    return (
        <main className="content">
            <div className="px-container">
                <div className="table-group mb-18">
                    {Object.entries(results).map(([key, users]) => {
                        if (!users.length) return null

                        return (
                            <div className="table table-responsive p-0 mb-10">
                                <div className="table-header capitalize">
                                    <h5>{key}</h5>
                                </div>
                                <div className="p-0">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Full Name</th>
                                                <th>Phone</th>
                                                <th style={{ width: '100%' }}>
                                                    Role
                                                </th>
                                                <th style={{ width: '80px' }}>
                                                    Email
                                                </th>
                                                <th style={{ width: '80px' }}>
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <React.Fragment key={key}>
                                                {users.map((user) => (
                                                    <tr key={user.id}>
                                                        <td className="min-w-250">
                                                            {user.fullName}
                                                        </td>
                                                        <td>{user.phone}</td>
                                                        <td>
                                                            {user.roles.map(
                                                                (
                                                                    role: UserRoleEnum,
                                                                ) => (
                                                                    <span
                                                                        key={
                                                                            role
                                                                        }
                                                                        className="role-label"
                                                                    >
                                                                        <span>
                                                                            {ROLE_LABELS[
                                                                                role
                                                                            ] ||
                                                                                role}
                                                                        </span>
                                                                    </span>
                                                                ),
                                                            )}
                                                        </td>
                                                        <td className="min-w-250">
                                                            {user.email}
                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn--primary-gradient btn--xs fullRadius"
                                                                onClick={() =>
                                                                    navigate(
                                                                        `/user/${user.id}`,
                                                                    )
                                                                }
                                                            >
                                                                <span className="text--xs">
                                                                    View
                                                                </span>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </React.Fragment>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </main>
    )
}

export default SearchPage
